import React from 'react'
import '../css/footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2020 Airbnb clone! No rights reserved - this is a demo!</p>
            <p>Privacy · Terms · Sitemap · Company Details</p>
        </div>
    )
}

export default Footer